const MobileMenu = () => {

    // Fetch all mobile menu items
    let items = document.querySelectorAll('.mobile-menu__item--parent');

    // Loop through all menu items that contain submenus
    Array.from(items).forEach( item => {

        // Locate the arrow wrapper which will essentially be the trigger for this menu
        // opening and closing
        let arrow = item.querySelector('.mobile-menu__arrow-wrap');

        // If we have an arrow, proceed
        if (typeof arrow != "undefined" && arrow != null) {
            
            // Add event listened for when the user clicks on the <li>
            arrow.addEventListener('click', () => {

                // If the <li> already has the active class
                if (item.matches('.mobile-menu__item--active')) {
                    // Remove the active class
                    item.classList.remove('mobile-menu__item--active');
                } else {
                    // Add the active class
                    item.classList.add('mobile-menu__item--active');
                }
            });
        }
    });
}

export default MobileMenu;